export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.2.18-1742.02',
  commitId: 'bc2d9819f718343d7ff7364972bedda5d51f54ab',
  commitTime: '2026-02-18T17:42:02.000Z',
});
